module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "verify"
  }, [_c('div', [_c('Tabs', {
    attrs: {
      "animated": false
    },
    on: {
      "on-click": _vm.changeType
    }
  }, _vm._l((_vm.types), function(type) {
    return _c('TabPane', {
      attrs: {
        "label": type.name,
        "name": type.id.toString()
      }
    }, [_c('div', {
      staticClass: "button-list"
    }, _vm._l((_vm.subTypesMap[type.id]), function(subType) {
      return _c('Button', {
        attrs: {
          "shape": "circle",
          "type": _vm.currentSubTypeId === subType.id ? 'primary' : 'ghost',
          "size": "large"
        },
        on: {
          "click": function($event) {
            _vm.changeSubType(subType.id)
          }
        }
      }, [_vm._v(_vm._s(subType.name))])
    }))])
  }))], 1), _vm._v(" "), _c('ul', {
    staticClass: "msg-list"
  }, _vm._l((_vm.msgs), function(msg) {
    return _c('li', {
      staticClass: "one-msg"
    }, [((msg.msgStatus === 1 || msg.msgStatus === 5) && (msg.typeWeight === 2 || msg.typeWeight === 3)) ? _c('span', {
      staticClass: "unread-icon"
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "create-time"
    }, [_vm._v(_vm._s(msg.msgTime))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(msg.msgDesc))]), _vm._v(" "), _c('div', {
      staticClass: "msgContent"
    }, [_c('p', [_vm._v(_vm._s(msg.content))])]), _vm._v(" "), _c('div', {
      staticClass: "action-area"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((msg.msgStatus === 5 || msg.msgStatus === 6) && msg.typeWeight === 1),
        expression: "(msg.msgStatus === 5 || msg.msgStatus === 6) && msg.typeWeight===1"
      }],
      staticClass: "text-info"
    }, [_vm._v("已读")]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (msg.msgStatus === 5 && msg.typeWeight !== 1),
        expression: "msg.msgStatus === 5 && msg.typeWeight!==1"
      }],
      staticClass: "btn btn-link",
      on: {
        "click": function($event) {
          _vm.handle(msg)
        }
      }
    }, [_vm._v(_vm._s(_vm.getBtnTextByMessage(msg)))]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (msg.msgStatus === 1 && msg.typeWeight !== 1),
        expression: "msg.msgStatus === 1 && msg.typeWeight!==1"
      }],
      staticClass: "btn btn-link",
      on: {
        "click": function($event) {
          _vm.handle(msg)
        }
      }
    }, [_vm._v(_vm._s(_vm.getBtnTextByMessage(msg)))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (msg.msgStatus === 2),
        expression: "msg.msgStatus === 2"
      }],
      staticClass: "text-info"
    }, [_vm._v("已过期")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (msg.msgStatus === 3),
        expression: "msg.msgStatus === 3"
      }],
      staticClass: "text-info"
    }, [_vm._v("已解决")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (msg.msgStatus === 4),
        expression: "msg.msgStatus === 4"
      }],
      staticClass: "text-info"
    }, [_vm._v("无法解决")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('Page', {
    attrs: {
      "page-size": _vm.LIST_COUNT,
      "current": _vm.page,
      "total": _vm.paging.total,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29c51e56","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/notification/verify.vue
// module id = 897
// module chunks = 0